import { REEL_NUMBERS, SYMBOLS_PER_REEL } from "./config/reelConfig";
import { IPos } from "./server/getServerResposesFun";
const coinNumberUnit = 0.1; // in cents

export function isFireFox(): boolean {
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    if (/firefox/i.test(ua)) return true;

    const uaData = (navigator as any).userAgentData;
    if (uaData?.brands?.some((b: any) => /firefox/i.test(b.brand))) return true;
    if (uaData?.platform === 'Android' && uaData?.brands?.some((b: any) => /firefox/i.test(b.brand))) return true;
    return typeof (window as any).InstallTrigger !== 'undefined';
}

export function getValues(dataValues: string[]): number[][] {
    const coinValues: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
        Array(SYMBOLS_PER_REEL).fill(0)
    );
    for (let i = 0; i < dataValues.length; i++) {
        const p = Number(i);
        const reelNum = p % REEL_NUMBERS;          // Column number (reelId)
        const posNum = Math.floor(p / REEL_NUMBERS); // Row number (position)
        coinValues[reelNum][posNum] = Number(dataValues[i]) * coinNumberUnit;
    }
    return coinValues;
}

export function getPositions(dataPositions: string[]): IPos[] {
    let positions: IPos[] = [];
    for (let i = 0; i < dataPositions.length; i++) {
        const p = Number(dataPositions[i]);
        const reelNum = p % REEL_NUMBERS;          // Column number (reelId)
        const posNum = Math.floor(p / REEL_NUMBERS); // Row number (position)
        const pos: IPos = {
            reelNum: reelNum,
            posNum: posNum
        };
        positions.push(pos);
    }
    return positions;
}